// Modules
import styled from 'styled-components';

// Styles
import { BodyBoldTwo } from '../../styles/common/typo.styles';

// Types
import { styledComponentProps } from '../../types/theme';

export const Footer = styled.div`
	width: 34%;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		width: 100%;
	}
`;

export const AdditionalInfo = styled.div`
	display: none;
	@media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
		width: 100%;
		display: block;
	}
`;

export const Social = styled.div`
	display: flex;
	margin-top: 20px;
`;

export const Links = styled.div`
	display: flex;
	margin: 0 15px;
`;

export const Link = styled.a`
	display: flex;
	margin: 0 7px;
	cursor: pointer;
`;

export const SocialIcon = styled.img`
	width: 22px;
	height: 22px;
`;
